module.exports = __webpack_public_path__ + "static/media/2015_conf_Creating_Meaning.a70f6c9a.png";